import LayoutOne from './LayoutOne'

LayoutOne.install = Vue => {
    vue.component(LayoutOne.name, LayoutOne)
}

export default LayoutOne